// extracted by mini-css-extract-plugin
export default {"storeIcon":"xSqmQPqY","dropdownButton":"OfCpvGDw Xp8onaNV"};